import EFPic from '../../UI/EFPic';
import css from './index.module.scss';
import { getBrandsMap } from '@/constants/where-to-buy';
import { useGlobal } from '@/utils/useGlobal';

export default function BrandLists() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const { brandListsCur, brandsMap } = getBrandsMap(t, locale);
    const onBrandClick = (brand: any) => {
        if (brand?.link) {
            window.open(brand?.link, '_blank');
        }
    };
    return (
        <div className={`brand-lists ${css['brand-lists']}`}>
            {Object.keys(brandListsCur)?.length > 0 && (
                <ul className="brands">
                    <div className="countryName">{brandListsCur?.country}</div>
                    {brandListsCur?.brands?.map((brand: any, k: number) => (
                        <li className={`brandList ${brand?.link ? '' : 'noLink'}`} key={`curCountry_${k}`} onClick={() => onBrandClick(brand)}>
                            <EFPic src={brand?.img} alt="logo" aria-label="logo" />
                            {brand?.bigImg && (
                                <div className="brandListHover">
                                    <div className="hoverImg">
                                        <EFPic src={brand?.bigImg?.img} alt={brand?.bigImg?.title} aria-label={brand?.bigImg?.title} />
                                    </div>
                                    <p className="hoverTitle">{brand?.bigImg?.title}</p>
                                    <p className="hoverDesc">{brand?.bigImg?.desc}</p>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            )}
            {locale !== 'cn' &&
                Object.keys(brandsMap)
                    ?.filter((key: string) => key !== locale && key !== 'cn' && brandsMap[key]?.brands?.length > 0)
                    ?.map((country: any) => (
                        <ul className="brands" key={`otherCountry_${country}`}>
                            <div className="countryName">{brandsMap[country]?.country}</div>
                            {brandsMap[country]?.brands?.map((brand: any, k: number) => (
                                <li className={`brandList ${brand?.link ? '' : 'noLink'}`} key={`${country}_brand_${k}`} onClick={() => onBrandClick(brand)}>
                                    <EFPic src={brand?.img} alt="logo" aria-label="logo" />
                                </li>
                            ))}
                        </ul>
                    ))}
        </div>
    );
}
